import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export interface AcceptClosingDateProposalArg {
    engagementId: number;
    proposalId: string;
    comment: string;
}

export const AcceptClosingDateProposal = createAsyncThunk(
    'closingDate/accept',
    async (arg: AcceptClosingDateProposalArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${arg.engagementId}/ClosingDate/Proposals/${arg.proposalId}/Accept`,
            { comment: arg.comment }
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while accepting the closing date proposal.';
            createNotification(message, 'error');
            throw new Error('Failed to accept closing date proposal');
        }

        createNotification('Closing date proposal accepted.', 'success');
        return response.data as EngagementClosingDate;
    }
);
